import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { InvoiceForm } from './InvoiceForm'
import AppLayout from '../common/AppLayout'
import AppTitle from '../common/AppTitle'

export const InvoiceAddPage = () => {
    const {t} = useTranslation()

    useEffect(() => {

    }, [])

    return (
        <AppLayout>
            <AppTitle append={<Link to={'/app/invoices'}>
                <button className="btn amani-primary">{t('back')}</button>
            </Link>}>{t('new_invoice')}</AppTitle>
            <InvoiceForm/>
        </AppLayout>
    )
}